// extracted by mini-css-extract-plugin
export default {"heading":"Hu-z","createAccount":"Iu-z","disabled":"Ju-z","copy":"Ku-z","terms":"Lu-z"};